import { ChangeEvent } from 'react'

export const handleAuthCodeChange = (
  e: ChangeEvent<HTMLInputElement>,
  onChangeController: (...event: unknown[]) => void,
) => {
  const numberPattern = /^[0-9]+$/
  const value = e.currentTarget.value

  if (value.length > 6) return
  if (value && !value.match(numberPattern)) return

  onChangeController(e)
}

export const handleBackupCodeChange = (
  e: ChangeEvent<HTMLInputElement>,
  onChangeController: (...event: unknown[]) => void,
) => {
  const value = e.currentTarget.value

  if (value.length > 8) return

  onChangeController(e)
}
